import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { UserContext } from './contexts/UserContext';
import jwt_decode from 'jwt-decode';
import './App.css';
import LoginPage from './pages/LoginPage';
import PostsPage from './pages/PostsPage';
import ImagePage from './pages/ImagePage';
import SignupPage from './pages/SignupPage';

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const initialLoginState = () => {
      if (!localStorage.getItem('token')) return false;

      return jwt_decode(localStorage.getItem('token'));
    };

    setIsLoggedIn(initialLoginState());
  }, []);

  return (
    <Router>
      <div className="App">
        <UserContext.Provider value={{ isLoggedIn, setIsLoggedIn }}>
          <Switch>
            <Route exact path="/login">
              {!isLoggedIn ? <LoginPage /> : <Redirect to={`/user/${isLoggedIn.username}`} />}
            </Route>
            <Route exact path="/signup">
              {!isLoggedIn ? <SignupPage /> : <Redirect to={`/user/${isLoggedIn.username}`} />}
            </Route>
            <Route exact path="/user/:username">
              <PostsPage />
            </Route>
            <Route exact path="/user/:username/image/:imageId">
              <ImagePage />
            </Route>
            <Redirect to="/user/miikka" />
          </Switch>
        </UserContext.Provider>
      </div>
    </Router>
  );
};

export default App;
